import { attachedFileFragment } from '@reconcept-platform/shared/data-access';
import { gql } from 'apollo-angular';
import { qualityInstrumentDetailFragment } from '../quality-instrument/quality-instrument.fragments';
import { workspaceUserItemFragment } from '../user/user.fragments';
import { workspaceViewerCanFragment } from '../workspace/workspace.fragments';
import { eventCardItemForExportFragment, eventCardItemFragment } from './event-card.fragments';

export const EventCardItemQuery = gql`
  query EventCardItemQuery($id: ID!) {
    node(id: $id) {
      ... on EventCard {
        ...EventCardItemFragment

        workspace {
          id
          title
          dashboard {
            id
            dashboardFormat {
              id
              shortName
            }
          }
          ...WorkspaceViewerCanFragment
        }

        users {
          nodes {
            ...WorkspaceUserItem
          }
        }

        linkedCards {
          ... on EventCard {
            id
            title
            startDate
            endDate
            eventCardStatus
          }
          ... on GoalCard {
            id
            title
            severity
            featured
            startDate
            endDate
            goalCardStatus
          }
        }

        qualityInstrument {
          ...QualityInstrumentDetail
        }
      }
    }
  }
  ${workspaceViewerCanFragment}
  ${eventCardItemFragment}
  ${workspaceUserItemFragment}
  ${qualityInstrumentDetailFragment}
`;

export const TimelineWithEventCardsQuery = gql`
  query TimelineWithEventCardsQuery($workspaceIds: [ID!], $status: [EventCardStatusEnum!]) {
    eventCards(workspaceIds: $workspaceIds, status: $status) {
      nodes {
        id
        title
        createdAt
        archivedAt
        completedAt
        startDate
        endDate
      }
    }
  }
`;

export const EventCardTilesQuery = gql`
  query EventCardTilesQuery($workspaceIds: [ID!], $status: [EventCardStatusEnum!]) {
    eventCards(workspaceIds: $workspaceIds, status: $status) {
      nodes {
        ...EventCardItemFragment

        users {
          nodes {
            ...WorkspaceUserItem
          }
        }
      }
    }
  }
  ${workspaceUserItemFragment}
  ${eventCardItemFragment}
`;

export const EventCardTilesForExportQuery = gql`
  query EventCardTilesForExportQuery($workspaceIds: [ID!], $status: [EventCardStatusEnum!]) {
    eventCards(workspaceIds: $workspaceIds, status: $status) {
      nodes {
        ...EventCardItemForExportFragment

        users {
          nodes {
            ...WorkspaceUserItem
          }
        }
      }
    }
  }
  ${workspaceUserItemFragment}
  ${eventCardItemForExportFragment}
`;

export const EventCardWithLinkedCardsQuery = gql`
  query EventCardWithLinkedCardsQuery($id: ID!) {
    node(id: $id) {
      ... on EventCard {
        id

        linkedCards {
          ... on GoalCard {
            id
            createdAt
            title
            severity
            endDate
            startDate
          }
          ... on EventCard {
            id
            createdAt
            title
            endDate
            startDate
          }
        }
      }
    }
  }
`;

export const eventCardWithCommentsQuery = gql`
  query EventCardWithComments($id: ID!) {
    node(id: $id) {
      ... on EventCard {
        ...EventCardItemFragment

        cardComments {
          nodes {
            id
            attachedFiles {
              ...AttachedFile
            }
          }
        }
      }
    }
  }
  ${eventCardItemFragment}
  ${attachedFileFragment}
`;
